import { LLMRoleConfigMap } from '../../../types';

type RoleKey = Exclude<keyof LLMRoleConfigMap, 'directorMarkMapping'>;

export interface LLMRoleOverrideOption {
  key: RoleKey;
  label: string;
}

type Translate = (key: string) => string;

const ROLE_KEYS: RoleKey[] = [
  'pronounResolve',
  'extract',
  'videoPrompt',
  'assetMatch',
  'scriptNormalize',
  'assetKeyword',
  'castingTags',
  'stylingTags',
  'languageRewrite',
];

const STYLE_MODAL_LABEL_KEYS: Record<RoleKey, string> = {
  pronounResolve: 'pronounResolve',
  extract: 'assetExtract',
  videoPrompt: 'shotSkillLabel',
  assetMatch: 'assetMatchLabel',
  scriptNormalize: 'scriptSkillLabel',
  assetKeyword: 'assetKeyword',
  castingTags: 'castingTags',
  castingRank: 'castingRank',
  stylingTags: 'stylingTags',
  languageRewrite: 'langRewrite',
  refTranslate: 'refTranslate',
  analyticsReport: 'analyticsReport',
};

const TEMPLATE_LABEL_KEYS: Record<RoleKey, string> = {
  pronounResolve: 'rolePronounResolve',
  extract: 'roleExtract',
  videoPrompt: 'roleVideoPrompt',
  assetMatch: 'roleAssetMatch',
  scriptNormalize: 'roleScriptNormalize',
  assetKeyword: 'roleAssetKeyword',
  castingTags: 'roleCastingTags',
  castingRank: 'roleCastingRank',
  stylingTags: 'roleStylingTags',
  languageRewrite: 'roleLanguageRewrite',
  refTranslate: 'roleRefTranslate',
  analyticsReport: 'roleAnalyticsReport',
};

export function buildLLMRoleOverrideOptions(t: Translate, namespace: 'styleModal' | 'template'): LLMRoleOverrideOption[] {
  const labelKeys = namespace === 'styleModal' ? STYLE_MODAL_LABEL_KEYS : TEMPLATE_LABEL_KEYS;
  return ROLE_KEYS.map(key => ({
    key,
    label: t(`${namespace}.${labelKeys[key]}`),
  }));
}
